import { render } from "./RacesView.vue?vue&type=template&id=5518be9a&scoped=true"
import script from "./RacesView.vue?vue&type=script&lang=js"
export * from "./RacesView.vue?vue&type=script&lang=js"

import "./RacesView.vue?vue&type=style&index=0&id=5518be9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5518be9a"]])

export default __exports__